<template>
<div class="label-group">
    <div class="label-group--label">{{ label }}:</div>
    <div class="label-group--val">{{ value }}</div>
</div>
</template>

<!-- -------------------------------------------------------------------------------- -->

<script>
export default {
    name: "LabelGroup",
    props: {
        label: {
            required: true
        },
        value: {
            required: true
        },
    }
}
</script>

<!-- -------------------------------------------------------------------------------- -->

<style scoped>
.label-group {
    margin: 0 0 6px 0;
}

.label-group--label {
    font-family: var(--font);
    font-weight: bold;
}

.label-group--val {
    font-weight: normal;
    line-height: 24px;
}
</style>